import React, { useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { EMPTY_STRING, toastMessages, toastType } from "../../constants";
import {
  PRODUCT_TYPES_ENUMS,
  SET_BY_MARGIN_ENUMS,
  PRICING_RULE_TYPES,
} from "../../system/globalEnums";
import {
  filterApplyToSearchOptions,
  getProductMargnColumns,
  customToast,
} from "../../shared/utility";
import { DeleteIcon } from "../../assets/icons/iconsProvider";
import AddPricingRule from "../../shared/components/pricingRule/AddPricingRule";
import { Modal } from "react-bootstrap";

const AddCustomSalesTaxRule = ({
  show = false,
  onHide = () => {},
  onSubmit = () => {},
  itemOrganization,
  isEditingSaleTax,
  currentEditingSaleTax,
  productConditionList,
  selectedCondition,
  setSelectedCondition,
  productTags,
  selectedTags,
  setSelectedTags,
  handleSelectedTagsChange,
  setByFilter,
  setSetByFilter,
  filterProductType,
  setFilterProductType,
  filterProductCategory,
  setFilterProductCategory,
  defaultCategorySortFieldId,
  setDefaultCategorySortFieldId,
  setSelectedCategories,
  selectedCategories,
}) => {
  const { customTypes, customCategories, customSubCategories } =
    itemOrganization || {};
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    if (show && isEditingSaleTax && currentEditingSaleTax) {
      setSetByFilter(
        currentEditingSaleTax.taxType ?? SET_BY_MARGIN_ENUMS.TYPE.value
      );
      setSelectedCategories(currentEditingSaleTax.taxGroup ?? []);
    }
  }, [
    show,
    isEditingSaleTax,
    currentEditingSaleTax,
    setSetByFilter,
    setSelectedCategories,
  ]);

  const filteredTypes = useMemo(
    () =>
      customTypes?.filter(
        (item) => item.productType !== PRODUCT_TYPES_ENUMS.ALL
      ),
    [customTypes]
  );

  const searchCategories = useMemo(
    () =>
      filterApplyToSearchOptions(
        setByFilter,
        filteredTypes,
        customCategories,
        customSubCategories,
        filterProductType,
        filterProductCategory,
        selectedCategories
      ),
    [
      setByFilter,
      filteredTypes,
      customCategories,
      customSubCategories,
      filterProductType,
      filterProductCategory,
      selectedCategories,
    ]
  );

  const removeSelectedCategory = (categoryName) => {
    setSelectedCategories((prev) =>
      prev.filter((c) => c.name !== categoryName)
    );
  };

  const categoriesColumn = [
    {
      id: "categoryName",
      name: "Category Name",
      selector: (row) => row.name,
      cell: (row) => <span className="users-cell-max-size">{row.name}</span>,
      sortable: true,
      sortDirection: null,
    },
    {
      id: "action",
      name: "",
      cell: (row) => (
        <button
          type="button"
          onClick={() => removeSelectedCategory(row.name)}
          id={`tool-${row.id}`}
          className="action-Button-Wrapper"
        >
          <DeleteIcon className="cursor-pointer" />
        </button>
      ),
      sortable: false,
      width: "5%",
    },
  ];

  const productMarginColumns = getProductMargnColumns(
    searchCategories,
    () => {},
    selectedCategories,
    setSelectedCategories
  );

  const handleSetByChange = (option) => {
    if (option === setByFilter) return;
    setSetByFilter(option);
    setSelectedCategories([]);
    if (option !== SET_BY_MARGIN_ENUMS.PRODUCT.value) {
      setSelectedTags([]);
      setSelectedCondition(productConditionList[0]);
    }
  };

  const resetForm = () => {
    setSetByFilter(SET_BY_MARGIN_ENUMS.TYPE.value);
    setSelectedCategories([]);
    setFilterProductType(EMPTY_STRING);
    setFilterProductCategory(EMPTY_STRING);
    setDefaultCategorySortFieldId(undefined);
    setSelectedTags([]);
    setSelectedCondition(productConditionList[0]);
  };

  const handleHide = () => {
    resetForm();
    onHide();
  };

  const handleSubmit = (values) => {
    if (selectedCategories.length === 0) {
      customToast(toastMessages.PLEASE_SELECT_CATEGORIES, toastType.ERROR);
      return;
    }
    onSubmit({ ...values, selectedCategories });
  };

  const editCategory = isEditingSaleTax
    ? {
        id: currentEditingSaleTax?.id,
        setBy: currentEditingSaleTax?.taxType,
        saleTaxRate: currentEditingSaleTax?.saleTaxRate ?? EMPTY_STRING,
      }
    : undefined;

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      animation={true}
      centered
      backdrop="static"
      className="add-inventory-modal"
    >
      <AddPricingRule
        isEdit={isEditingSaleTax}
        columns={columns}
        setColumns={setColumns}
        productTags={productTags}
        customTypes={customTypes}
        setByFilter={setByFilter}
        selectedTags={selectedTags}
        editCategory={editCategory}
        itemMarginUnit={false}
        categoriesColumn={categoriesColumn}
        searchCategories={searchCategories}
        customCategories={customCategories}
        handleSetByChange={handleSetByChange}
        modalHandleSubmit={handleSubmit}
        filterProductType={filterProductType}
        setItemMarginUnit={() => {}}
        selectedCondition={selectedCondition}
        handleSwitchChange={() => {}}
        selectedCategories={selectedCategories}
        customSubCategories={customSubCategories}
        modalCheckBoxStatus={false}
        setSearchCategories={() => {}}
        setFilterProductType={setFilterProductType}
        handleCategorySelect={() => {}}
        productConditionList={productConditionList}
        setSelectedCategories={setSelectedCategories}
        productMarginColumns={productMarginColumns}
        filterProductCategory={filterProductCategory}
        setSelectedCondition={setSelectedCondition}
        toggleCustomTradeModal={handleHide}
        handleSelectedTagsChange={handleSelectedTagsChange}
        setFilterProductCategory={setFilterProductCategory}
        defaultCategorySortFieldId={defaultCategorySortFieldId}
        setDefaultCategorySortFieldId={setDefaultCategorySortFieldId}
        addPricingRuleType={PRICING_RULE_TYPES.SALE_TAX}
        title={
          isEditingSaleTax
            ? "Edit Custom Sales Tax Rule"
            : "Add Custom Sales Tax Rule"
        }
      />
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  itemOrganization: state.itemOrganization,
});
const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddCustomSalesTaxRule);
